var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "编辑顶部信息",
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "170px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "顶部背景图:", prop: "backGroundPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload,
                              },
                            },
                            [
                              _vm.ruleForm.backGroundPic &&
                              _vm.ruleForm.backGroundPic != null
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.backGroundPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.backGroundPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("backGroundPic")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "建议宽度750，高度不限制，PNG格式图片 (默认展示白色背景)"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "昵称、邀请码文字色:",
                        prop: "textColor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.textColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "textColor", $$v)
                              },
                              expression: "ruleForm.textColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.ruleForm.textColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "textColor", $$v)
                              },
                              expression: "ruleForm.textColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("默认背景色 #333333")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否展示微信绑定提醒：",
                        prop: "wxRemind",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.wxRemind,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "wxRemind", $$v)
                            },
                            expression: "ruleForm.wxRemind",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "联系客服入口：",
                        prop: "contactUsEntry",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.contactUsEntry,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "contactUsEntry", $$v)
                            },
                            expression: "ruleForm.contactUsEntry",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服图标:", prop: "customerPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload1,
                              },
                            },
                            [
                              _vm.ruleForm.customerPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.customerPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: require("@/assets/kf.png"),
                                          fit: "contain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm.ruleForm.customerPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("customerPic")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("建议120*120，PNG格式图片")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推荐人入口：", prop: "referrerEntry" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.referrerEntry,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "referrerEntry", $$v)
                            },
                            expression: "ruleForm.referrerEntry",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推荐人图标:", prop: "referrerPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload2,
                              },
                            },
                            [
                              _vm.ruleForm.referrerPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.referrerPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: require("@/assets/tjr.png"),
                                          fit: "contain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm.ruleForm.referrerPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("referrerPic")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "建议120*120，PNG格式图片（注意！推荐人入口仅会向“团队代理”身份用户展示）"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "消息入口：", prop: "messageEntry" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.messageEntry,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "messageEntry", $$v)
                            },
                            expression: "ruleForm.messageEntry",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "消息图标:", prop: "messagePic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload3,
                              },
                            },
                            [
                              _vm.ruleForm.messagePic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.messagePic,
                                      fit: "contain",
                                    },
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: require("@/assets/xx.png"),
                                          fit: "contain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm.ruleForm.messagePic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("messagePic")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("建议120*120，PNG格式图片")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "设置图标:", prop: "settingPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload4,
                              },
                            },
                            [
                              _vm.ruleForm.settingPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.settingPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: require("@/assets/sz.png"),
                                          fit: "contain",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm.ruleForm.settingPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic("settingPic")
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("建议120*120，PNG格式图片")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }